export const en = {
    assign: 'Set',
    cancel: 'Cancel',
    'cpa-strategy-note':
        'The bid will only apply to filters with the "Optimizing the number of conversions" and "Optimizing the number of clicks" strategies.',
    'cpc-strategy-note': 'The bid will only apply to filters with the "Optimizing the number of clicks" strategy.',
    'rate-label': 'Set a {rateType} bid'
};
